<template>
  <div>
    <div class="comm_title_wrap">
      <h4>{{ $t('MSG_TXT_ATTH_GROUP_INFO') }}</h4>
    </div>
    <div class="comm_view_wrap">
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_MDLE')"
            :required="false"
            :vertical="false"
          />
        </div>
        <div class="col-xs-5">
          <sui-module-submodule-select
            ref="smComboFrame0"
            :disabled="true"
            :pageId="pageId"
            :selectedMd="frame0.selectData.COD_MDLE"
            :selectedSmd="frame0.selectData.COD_SMDLE"
          />
        </div>
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_ATTH_GRP_ID')"
            :required="false"
            :vertical="false"
          />
        </div>
        <div class="col-xs-5">
          <sui-text-field
            v-model="frame0.attachGroupId"
            :readonly="true"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_ATTH_GRP_NM')"
            :required="false"
            :vertical="false"
          />
        </div>
        <div class="col-xs-5">
          <sui-text-field
            v-model="frame0.attachGroupName"
            :readonly="true"
          />
        </div>
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_ATTH_ITEM_MGT_YN')"
            :required="false"
            :vertical="false"
          />
        </div>
        <div class="col-xs-5">
          <sui-yn-select
            ref="mgtYnSelect"
            :disabled="true"
            :selected="frame0.selectData.COD_MGT_YN"
          />
        </div>
      </div>
    </div>
    <div class="comm_title_wrap">
      <h4>{{ $t('MSG_TXT_ATTH_ITEM_LIST') }}</h4>
    </div>
    <div class="comm_gridTop_wrap">
      <div class="btn_wrapL">
        <sui-button
          v-if="btnShow"
          type="button"
          class="comm_btn_gridTop"
          @click="onClickAddRow"
        >
          {{ $t('MSG_BTN_ROW_ADD') }}
        </sui-button>
        <sui-button
          v-if="btnShow"
          type="button"
          class="comm_btn_gridTop"
          @click="onClickDelRow"
        >
          {{ $t('MSG_BTN_ROW_DEL') }}
        </sui-button>
      </div>
    </div>
    <sui-grid
      ref="grid"
      :hideHeader="true"
      :initial-pagesize="3"
      :pagesizeoptions="[3]"
      :multiselect="true"
      :columns="gridColumns0"
      :dataset="'dsItem'"
    />
    <div class="comm_btn_wrap">
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onClickClose"
      >
        {{ $t('MSG_BTN_CANCEL') }}
      </sui-button>
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="moveTab(-2)"
      >
        {{ $t('MSG_BTN_PREV') }}
      </sui-button>
      <sui-button
        v-permission:update="pageId"
        type="button"
        :class="saveClass"
        @click="onClickSave(attachGroupDeterminYn,'save')"
      >
        {{ $t('MSG_BTN_SAVE') }}
      </sui-button>
      <sui-button
        v-if="determinDisabledYn"
        v-permission:update="pageId"
        type="button"
        class="comm_btn_solid"
        @click="onClickSave('Y','determin')"
      >
        {{ $t('MSG_BTN_DTRM') }}
      </sui-button>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

const CODE_KEYS = ['COD_ATTH_EXTS'];

export default {
  name: 'PGE_CMD_00003_T03', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: null,
    },
    tabData: {
      type: Object,
      default: null,
    },
    idx: {
      type: Number,
      default: 2,
    },
    attachGroupId: {
      type: String,
      default: null,
    },
    selectedGridRowData: {
      type: Object,
      default: null,
    },
    attachGroupDeterminYn: {
      type: String,
      default: 'N',
    },
  },
  data() {
    return {
      optionList: {
        COD_ATTH_EXTS: [],
        COD_NCSR_YN: [{
          key: 'Y',
          label: this.$t('MSG_TXT_NCSR'),
        }, {
          key: 'N',
          label: this.$t('MSG_TXT_SEL'),
        }],
      },
      frame0: {
        selectData: {
          COD_MDLE: {
            label: '',
            key: '',
          },
          COD_SMDLE: {
            label: '',
            key: '',
          },
          COD_MGT_YN: {
            label: '',
            key: '',
          },
        },
        attachGroupId: '',
        attachGroupName: '',
      },
      localdata0: [],
      localdata1: [],
      mlngDtlList: [],
      btnShow: true,
      determinDisabledYn: true,
      gridColumns0: [{
        text: this.$t('MSG_TXT_ITEM_NM'),
        datafield: 'multiLanguageList',
        width: '400px',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellMlngEditor(row, column, value, htmlElement, {
            pageId: this.pageId,
            multiLanguageIdField: 'attachItemMultiLanguageId',
          }, this.dsItem, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_HDQT_CNTL_YN'),
        datafield: 'headquarterControlYn',
        width: '100px',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellSegmentBox(row, column, value, htmlElement, {
            checkEditableFunction: this.checkEditableName,
          }, this.dsItem, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_NCSR_YN'),
        datafield: 'headquarterEssentialYn',
        width: '100px',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellSelect(row, column, value, htmlElement,
            {
              optionList: this.optionList.COD_NCSR_YN,
            }, this.dsItem, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_ARRAY_ORDER'),
        datafield: 'arrayalOrder',
        width: '100px',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement, {
            trim: true,
            maxlength: '4',
            mask: 'number',
            checkEditableFunction: this.checkEditableName,
          }, this.dsItem, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_EXTS'),
        datafield: 'attachPossibilityExtensionCode',
        width: '100px',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellSelect(row, column, value, htmlElement,
            {
              optionList: this.optionList.COD_ATTH_EXTS,
            }, this.dsItem, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      },
      {
        text: this.$t('MSG_TXT_ATTH_EXLD_PSBL_YN'),
        datafield: 'attachExcludePossibilityYn',
        width: '120px',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellSegmentBox(row, column, value, htmlElement, {
            checkEditableFunction: this.checkEditableName,
          }, this.dsItem, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      },
      {
        text: this.$t('MSG_TXT_STDD_FORM'),
        datafield: 'standardFormName',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellTextFieldWithButton(row, column, value, htmlElement, {
            textFieldProps: {
              readonly: true,
              disabled: true,
              checkEditableFunction: this.checkEditableName,
            },
            buttonProps: {
              name: this.$t('MSG_BTN_SELT'),
              disabled: false,
              checkEditableFunction: this.checkEditableName,
              style: 'comm_btn_InputScr',
            },
            handler: this.onClickStandardForm,
          }, this.dsItem, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      },
      ],
    };
  },
  computed: {
    saveClass() {
      if (utils.isEqual(this.attachGroupDeterminYn, 'Y')) {
        return 'comm_btn_solid';
      }
      return 'comm_btn_border';
    },
  },
  watch: {},
  datasets: [{
    id: 'dsItem',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'standardFormId', map: 'standardFormId' },
      { type: 'string', name: 'standardFormName', map: 'standardFormName' },
      { type: 'string', name: 'attachItemId', map: 'attachItemId' },
      { type: 'string', name: 'attachItemName', map: 'attachItemName' },
      { type: 'string', name: 'arrayalOrder', map: 'arrayalOrder' },
      { type: 'string', name: 'attachExcludePossibilityYn', map: 'attachExcludePossibilityYn' },
      { type: 'string', name: 'headquarterControlYn', map: 'headquarterControlYn' },
      { type: 'string', name: 'headquarterEssentialYn', map: 'headquarterEssentialYn' },
      { type: 'string', name: 'attachPossibilityExtensionCode', map: 'attachPossibilityExtensionCode' },
      { type: 'string', name: 'attachItemManagementYn', map: 'attachItemManagementYn' },
      { type: 'string', name: 'attachItemMultiLanguageId', map: 'attachItemMultiLanguageId' },
      { type: 'array', name: 'multiLanguageList', map: 'multiLanguageList' },
    ],
  },
  {
    id: 'dsItemDelete',
    type: 'local',
    data: 'localdata1',
    datafields: [
      { type: 'string', name: 'standardFormId', map: 'standardFormId' },
      { type: 'string', name: 'standardFormName', map: 'standardFormName' },
      { type: 'string', name: 'attachItemId', map: 'attachItemId' },
      { type: 'string', name: 'attachItemName', map: 'attachItemName' },
      { type: 'string', name: 'arrayalOrder', map: 'arrayalOrder' },
      { type: 'string', name: 'attachExcludePossibilityYn', map: 'attachExcludePossibilityYn' },
      { type: 'string', name: 'headquarterControlYn', map: 'headquarterControlYn' },
      { type: 'string', name: 'headquarterEssentialYn', map: 'headquarterEssentialYn' },
      { type: 'string', name: 'attachPossibilityExtensionCode', map: 'attachPossibilityExtensionCode' },
      { type: 'string', name: 'attachItemManagementYn', map: 'attachItemManagementYn' },
      { type: 'string', name: 'attachItemMultiLanguageId', map: 'attachItemMultiLanguageId' },
      { type: 'array', name: 'multiLanguageList', map: 'multiLanguageList' },
    ],
  }],
  mounted() {
    this.determinDisabledYn = !utils.isEqual(this.attachGroupDeterminYn, 'Y');

    this.commCodeSelect().then(() => {
      if (utils.isEmpty(this.attachGroupId)) {
        this.setAttachItemDefault();
      } else {
        this.setAttachItemList();
      }
    }).catch(() => {});
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {
    this.setGroupInfo();

    if (utils.isEmpty(this.attachGroupId)) {
      this.setAttachItemDefault();
    }

    // this.setAttachItemNameManagementN();
  },
  methods: {
    /**
     * 확장자 공통 code 목록 조회
     */
    commCodeSelect() {
      return http.mergeCodeList(this.pageId, CODE_KEYS, this.optionList).then(() => {
      }).catch(() => {});
    },
    /**
     * tab01 첨부항목 관리 여부 N 인 경우
     * 고정 row 항목명을 첨부그룹명과 동일하게 설정
     */
    setAttachItemNameManagementN() {
      if (utils.isEqual(this.tabData.t01.attachItemManagementYn, 'N')) {
        this.dsItem.setData(0, 'attachItemName', this.tabData.t01.localMultiLanguage);
      }
    },
    /**
     * 첨부항목 목록 조회
     */
    setAttachItemList() {
      http.request(this.pageId, 'DTS_CMD_00008', {
        path: {
          'attach-group-id': this.attachGroupId,
        },
      }).then(res => {
        const itemList = utils.clone(res.data);

        utils.forEach(itemList, (obj, key) => {
          itemList[key].arrayalOrder = obj.arrayalOrder.toString();
        });


        this.dsItem.setRawData(itemList); // 데이터 셋에 데이터를 넣는 함수

        // this.setAttachItemNameManagementN();
      });
    },
    /**
     * 첨부항목 초기 값 셋팅.
     * tab01 첨부항목 관리 여부 N 인 경우
     * 고정 1row 추가.
     */
    setAttachItemDefault() {
      const attachItemManagementYn = utils.isUndefined(this.dsItem.data[0])
        ? '' : this.dsItem.data[0].attachItemManagementYn;

      if (utils.isEqual(this.tabData.t01.attachItemManagementYn, 'N') && !utils.isEqual(attachItemManagementYn, 'N')) {
        const defaultRow = [{
          standardFormId: '',
          standardFormName: '',
          attachItemId: '',
          attachItemName: this.tabData.t01.localMultiLanguage,
          arrayalOrder: '1',
          attachExcludePossibilityYn: 'Y',
          headquarterControlYn: 'Y',
          headquarterEssentialYn: '',
          attachPossibilityExtensionCode: '',
          attachItemManagementYn: this.tabData.t01.attachItemManagementYn,
        }];

        this.dsItem.setRawData(defaultRow);
      } else if (utils.isEqual(this.tabData.t01.attachItemManagementYn, 'Y')
                 && utils.isEqual(attachItemManagementYn, 'N')) {
        this.dsItem.setRawData([]);
      }
    },
    /**
     * 첨부그룹정보 data SET
     */
    setGroupInfo() {
      this.frame0.selectData.COD_MDLE.key = this.tabData.t01.moduleCode;
      this.frame0.selectData.COD_SMDLE.key = this.tabData.t01.subModuleCode;
      this.frame0.selectData.COD_MGT_YN.key = this.tabData.t01.attachItemManagementYn;
      this.frame0.attachGroupId = this.tabData.t01.attachGroupId;
      this.frame0.attachGroupName = this.tabData.t01.localMultiLanguage;

      this.btnShow = utils.isEqual(this.tabData.t01.attachItemManagementYn, 'Y');
    },
    /**
     * 닫기
     */
    onClickClose() {
      this.$emit('onClickClose', false);
    },
    /**
     * 이전
     * tab 이동
     */
    moveTab(value) {
      const idx = this.idx + value;

      this.$emit('moveTab', idx);
    },
    /**
     * 부모화면에 현재 TAB의 DATA 저장.
     */
    dataSet() {
      const info = {
        attachItemList: this.dsItem.data,
      };

      this.$emit('setTabInfo', info, 't03');
    },
    /**
     * 첨부항목관리여부 (tab01) 값이 N인 경우
     * 특정 컬럼 입력 제한.
     */
    checkEditableName() {
      // rowData, columnName, dataset, grid
      if (utils.isEqual(this.tabData.t01.attachItemManagementYn, 'N')) {
        return false;
      }
      return true;
    },
    /**
     * grid button event
     */
    onClickAddRow() {
      const defaultRow = [{
        rowType: 'I',
        standardFormId: '',
        standardFormName: '',
        attachItemId: '',
        attachItemName: '',
        arrayalOrder: '',
        attachExcludePossibilityYn: 'N',
        headquarterControlYn: 'N',
        headquarterEssentialYn: '',
        attachPossibilityExtensionCode: '',
      }];
      this.dsItem.addRows(defaultRow);
    },
    onClickDelRow() {
      const deleteRows = [];
      const selectedIndexes = this.dsItem.getSelectedIndexes();

      if (!(selectedIndexes.length > 0)) {
        utils.messageBox('warning', this.$t('MSG_ALT_NOT_SEL_ITEM')); // 선택 된 항목이 없습니다.
        return false;
      }

      utils.forEach(selectedIndexes, index => {
        const rowId = this.dsItem.data[index]['dataset-row-id'];
        const rowIndex = utils.findIndex(this.dsItem.originalData, o => utils.isEqual(o['dataset-row-id'], rowId));

        if (rowIndex > -1) {
          deleteRows.push(this.dsItem.data[index]);
        }
      });

      this.dsItem.deleteRows(selectedIndexes);
      this.dsItemDelete.addRows(deleteRows);

      this.dsItem.clearSelection();

      return null;
    },
    /**
     * grid 표준양식 선택 팝업
     */
    onClickStandardForm(event, dataRow) {
      utils.openLayerPopup('PGE_CMD_00005', data => {
        // CALLBACK
        const itemData = utils.clone(this.dsItem.data);
        const rowId = dataRow['dataset-row-id'];
        const rowIndex = utils.findIndex(itemData, o => utils.isEqual(o['dataset-row-id'], rowId));

        if (!utils.isEmpty(data)) {
          this.dsItem.setData(rowIndex, 'standardFormName', data[0].documentName);
          this.dsItem.setData(rowIndex, 'standardFormId', data[0].documentId);
        }
      }, {
        pageInitialData: {},
        size: 'lg',
      });
    },
    /**
     * 저장
     */
    onClickSave(attachGroupDeterminYn, type) {
      const serviceName = (utils.isEmpty(this.attachGroupId) ? 'DTS_CMD_00009' : 'DTS_CMD_00010');
      const dataParam = {
        attachItemList: this.dsItem.data,
        attachItemDeleteList: this.dsItemDelete.data,
        attachGroupDeterminYn,
      };
      if (!this.validCheck()) return false; // null 값 체크

      // 다른 tab data 할당.
      utils.assign(dataParam, this.tabData.t01);
      utils.assign(dataParam, this.tabData.t02);

      // 신규등록인 경우만 id 중복체크
      if (utils.isEmpty(this.attachGroupId)) {
        http.request(this.pageId, 'DTS_CMD_00011', {
          query: {
            attachGroupId: dataParam.attachGroupId,
          },
        }).then(res => {
          if (res.data > 0) {
            this.moveTab(-2);
            // 이미 등록된 ID입니다.
            utils.messageBox('information', this.$t('MSG_ALT_IMG_RGST_ID'), null, () => {
              this.$emit('setFocus', 'inputAttachGroupId');
            });
          } else {
            // 서비스 호출
            utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
              this.dataSave(serviceName, dataParam, type);
            });
          }
        });
      } else {
        // 서비스 호출
        utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
          this.dataSave(serviceName, dataParam, type);
        });
      }

      return null;
    },
    dataSave(serviceName, dataParams, type) {
      http.request(this.pageId, serviceName, {
        data: dataParams,
      }).then(() => {
        utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'));
        // this.determinDisabledYn = utils.isEqual(this.attachGroupDeterminYn ,'N');
        if (utils.isEqual(type, 'determin')) {
          this.$emit('onClickClose', true);
        } else {
          this.$emit('onClickSearch');
        }
      });
    },
    /**
     * 저장
     */
    validCheck() {
      const tab01Data = this.tabData.t01;
      const attachItemList = this.dsItem.data;
      let itemListFlag = true;

      // tab01
      if (utils.isEmpty(tab01Data.moduleCode)) {
        this.moveTab(-2);
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_MDLE')));

        return false;
      }
      if (utils.isEmpty(tab01Data.subModuleCode)) {
        this.moveTab(-2);
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_SMDLE')));

        return false;
      }
      if (tab01Data.attachGroupId.length < 9) {
        this.moveTab(-2);
        utils.messageBox('warning',
          utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_ATTH_GRP_ID')),
          null, () => {
            this.$emit('setFocus', 'inputAttachGroupId');
          });

        return false;
      }
      if (utils.isEmpty(tab01Data.localMultiLanguage)) {
        this.moveTab(-2);
        utils.messageBox('warning',
          utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_LOCAL_LNG')),
          null, () => {
            this.$emit('setFocus', 'local');
          });

        return false;
      }
      if (utils.isEmpty(tab01Data.globalMultiLanguage)) {
        this.moveTab(-2);
        utils.messageBox('warning',
          utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_GLOBAL_LNG')),
          null, () => {
            this.$emit('setFocus', 'global');
          });

        return false;
      }
      if (utils.isEmpty(tab01Data.attachItemManagementYn)) {
        this.moveTab(-2);
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_ATTH_ITEM_MGT_YN')));

        return false;
      }
      if (utils.isEmpty(tab01Data.imagePreviewApplyYn)) {
        this.moveTab(-2);
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_IMG_PRVW_APPY_YN')));

        return false;
      }
      if (utils.isEmpty(tab01Data.attachRestrictionSize)) {
        this.moveTab(-2);
        utils.messageBox('warning',
          utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_RSLT_CAPA')),
          null, () => {
            this.$emit('setFocus', 'attachRestrictionSize');
          });

        return false;
      }
      if (utils.isEmpty(tab01Data.downloadHistoryManagementYn)) {
        this.moveTab(-2);
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_DLOAD_HIS_MGT_YN')));

        return false;
      }
      if (utils.isEmpty(tab01Data.downloadReasonInputYn)) {
        this.moveTab(-2);
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_DLOAD_RSN_INP_YN')));

        return false;
      }
      if (utils.isEmpty(tab01Data.fileEncryptionYn)) {
        this.moveTab(-2);
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_FILE_ENCR_YN')));

        return false;
      }

      // 첨부항목 리스트 (TAB3)
      if (attachItemList.length < 1) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_ATTH_ITEM')));

        return false;
      }

      utils.forEach(attachItemList, (obj, key) => {
        // if(utils.isEmpty(obj.attachItemName)){
        //   utils.messageBox('warning'
        // , utils.strFormat(this.$t('MSG_ALT_ROW_INPUT'), rowIndex, this.$t('MSG_TXT_ATTH_ITEM_NM'))
        // , null, () => {
        //     this.gridSetFocus(rowIndex, 'attachItemName');
        //   });

        //   itemListFlag= false;
        //   return false;
        // }
        if (utils.isEmpty(obj.headquarterControlYn)) {
          utils.messageBox('warning',
            utils.strFormat(this.$t('MSG_ALT_ROW_INPUT'), key + 1, this.$t('MSG_TXT_HDQT_CNTL_YN')),
            null, () => {
              this.gridSetFocus(key, 'headquarterControlY');
            });

          itemListFlag = false;
          return false;
        }
        if (utils.isEmpty(obj.headquarterEssentialYn)) {
          utils.messageBox('warning',
            utils.strFormat(this.$t('MSG_ALT_ROW_INPUT'), key + 1, this.$t('MSG_TXT_NCSR_YN')),
            null, () => {
              this.gridSetFocus(key, 'headquarterEssentialYn');
            });

          itemListFlag = false;
          return false;
        }
        if (utils.isEmpty(obj.arrayalOrder)) {
          utils.messageBox('warning',
            utils.strFormat(this.$t('MSG_ALT_ROW_INPUT'), key + 1, this.$t('MSG_TXT_ARRAY_ORDER')),
            null, () => {
              this.gridSetFocus(key, 'arrayalOrder');
            });

          itemListFlag = false;
          return false;
        }
        if (utils.isEmpty(obj.attachPossibilityExtensionCode)) {
          utils.messageBox('warning',
            utils.strFormat(this.$t('MSG_ALT_ROW_INPUT'), key + 1, this.$t('MSG_TXT_EXTS')),
            null, () => {
              this.gridSetFocus(key, 'attachPossibilityExtensionCode');
            });

          itemListFlag = false;
          return false;
        }
        if (utils.isEmpty(obj.attachExcludePossibilityYn)) {
          utils.messageBox('warning',
            utils.strFormat(this.$t('MSG_ALT_ROW_INPUT'), key + 1, this.$t('MSG_TXT_ATTH_EXLD_PSBL_YN')),
            null, () => {
              this.gridSetFocus(key, 'attachExcludePossibilityYn');
            });

          itemListFlag = false;
          return false;
        }
        // if (utils.isEmpty(obj.standardFormId) && !utils.isEqual(this.tabData.t01.attachItemManagementYn, 'N')) {
        //   utils.messageBox('warning',
        //     utils.strFormat(this.$t('MSG_ALT_ROW_INPUT'), key + 1, this.$t('MSG_TXT_STDD_FORM')),
        //     null, () => {
        //       this.gridSetFocus(key, 'standardFormId');
        //     });

        //   itemListFlag = false;
        //   return false;
        // }
        if (utils.isEmpty(obj.multiLanguageList)) {
          utils.messageBox('warning',
            utils.strFormat(this.$t('MSG_ALT_ROW_INPUT'), key + 1, this.$t('MSG_TXT_MLNG_CNTN')),
            null, () => {
              // this.gridSetFocus(rowIndex, 'multiLanguageList');
            });

          itemListFlag = false;
          return false;
        }
        const emptyContent = utils.find(obj.multiLanguageList, { multiLanguageContent: '' });
        if (emptyContent) {
          utils.messageBox('warning',
            utils.strFormat(this.$t('MSG_ALT_ROW_INPUT'), key + 1, this.$t('MSG_TXT_MLNG_CNTN')),
            null, () => {
              // this.gridSetFocus(rowIndex, 'multiLanguageList');
            });

          itemListFlag = false;
          return false;
        }
        return itemListFlag;
      });

      return itemListFlag;
    },
    gridSetFocus(rowIndex, datafield) {
      this.$refs.grid.$refs.grid.ensurerowvisible(rowIndex);

      const editor = this.$refs.grid.getCellEditor(rowIndex, datafield);

      if (editor) {
        editor.getComponentInstance().setFocus();
      }
    },
  },
};
</script>

<style scoped>
</style>
